import React, { useState, useEffect } from 'react'
import { Button, Container } from 'react-bootstrap'
import { motion, AnimatePresence } from 'framer-motion'
import { Link } from 'react-router-dom'
import './CookieConsent.css'

function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false)

  useEffect(() => {
    // Sprawdź czy użytkownik już wyraził zgodę
    const cookieConsent = localStorage.getItem('cookieConsent')
    if (!cookieConsent) {
      setShowConsent(true)
    }
  }, [])

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted')
    setShowConsent(false)
    // Włącz GA (jeśli był zablokowany)
    window.dataLayer = window.dataLayer || []
    function gtag() { window.dataLayer.push(arguments) }
    gtag('consent', 'update', {
      'analytics_storage': 'granted'
    })
  }

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected')
    setShowConsent(false)
    // Zablokuj GA
    window.dataLayer = window.dataLayer || []
    function gtag() { window.dataLayer.push(arguments) }
    gtag('consent', 'update', {
      'analytics_storage': 'denied'
    })
  }

  return (
    <AnimatePresence>
      {showConsent && (
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.4 }}
          className="cookie-consent-banner"
        >
          <Container>
            <div className="cookie-consent-content">
              <div className="cookie-consent-text">
                <h5 className="mb-2">Cookies i analityka</h5>
                <p className="mb-0">
                  Używamy Google Analytics do analizy ruchu i poprawy naszego serwisu. 
                  Cookies są wykorzystywane wyłącznie do celów analitycznych. 
                  Możesz przeczytać więcej w naszej{' '}
                  <Link to="/privacy" className="cookie-consent-link">
                    Polityce Prywatności
                  </Link>.
                </p>
              </div>
              <div className="cookie-consent-buttons">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={handleReject}
                  className="cookie-btn-reject"
                >
                  Odrzuć
                </Button>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={handleAccept}
                  className="cookie-btn-accept"
                >
                  Akceptuj
                </Button>
              </div>
            </div>
          </Container>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default CookieConsent
